import styled from "styled-components";
import { COLORS, TYPOGRAPHY } from "../../containers/impact-report/constants";

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px;
  margin-top: 32px;
`;

export const EmptyStateTitle = styled.div`
  ${TYPOGRAPHY.BODY_LARGE_MEDIUM}
  color: ${COLORS.NEUTRAL_500};
  margin-bottom: 8px;
`;

export const EmptyStateDescription = styled.div`
  ${TYPOGRAPHY.BODY_NORMAL_LIGHT}
  color: ${COLORS.NEUTRAL_300};
`;
